"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _ArrowLeft = _interopRequireDefault(require("@rsuite/icon-font/lib/direction/ArrowLeft"));

// Generated by script, don't edit it please.
var ArrowLeft = (0, _createSvgIcon["default"])({
  as: _ArrowLeft["default"],
  ariaLabel: 'arrow left',
  category: 'direction',
  displayName: 'ArrowLeft'
});
var _default = ArrowLeft;
exports["default"] = _default;
module.exports = exports.default;